// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: Arial, Helvetica, sans-serif;
}

body, input[text], button {
color: #888;
/* background-color:white; */
/* font-family: Cambria, Georgia; */
}


#candidate-detail {
background-color:white;
}

.srcoll-notes::-webkit-scrollbar {
-webkit-appearance: none;
width: 7px;
}

.srcoll-notes::-webkit-scrollbar-thumb {
border-radius: 4px;
background-color: rgba(0, 0, 0, .5);
box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.rowcenter {
margin-top: 30px;
display: flex;
justify-content: center;
align-items: flex-start;
width: 100%;
flex-direction: row;
}

.dropzone-container {
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: row;
}

.dropzone {
width: 75%;
min-width: 250px;
cursor: pointer;
/* height: 220px; */
padding: 1rem;
text-align: center;
border-radius: 20px;
border: dashed 1px #979797;
position: relative;
margin: 0 auto;
box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)
}




.dropzone input {
opacity: 0;
position: absolute;
z-index: 2;
width: 100%;
height: 100%;
top: 0;
left: 0;
cursor: pointer;
}

ul {
padding: 0px;
margin: 0px;
}

.dropzone label {
color: white;
background-image: linear-gradient(to right, #77A1D3, #79CBCA );
height: 32px;
width: 150px;
border-radius: 20px;
padding: 4px 8px;
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;
}

.dropzone h5 {
color: #aaabad;
font-weight: 700;
}


.fileover {
animation: shake 1s;
animation-iteration-count:infinite;
}

.file-list {
width: 90%;
display: flex;
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
flex-direction: row;
justify-content: center;
align-items: center;
margin-top: 15px;
border-radius: 10px;
padding: 5px
}


.name {
font-size: 14px;
font-weight: 500;
color: #353f4a;
margin: 0;
}

.size {
font-size: 12px;
font-weight: 500;
color: #a4a4a4;
margin: 0;
margin-bottom: 0.25rem;
}

.info {
width: 100%
}

@keyframes extend {
0% {width: 75%}
100% {width: 90%}
}

@keyframes shake {
0% {
    transform: translate(1px, 1px) rotate(0deg);
}

10% {
    transform: translate(-1px, -2px) rotate(-1deg);
}

20% {
    transform: translate(-3px, 0px) rotate(1deg);
}

30% {
    transform: translate(3px, 2px) rotate(0deg);
}

40% {
    transform: translate(1px, -1px) rotate(1deg);
}

50% {
    transform: translate(-1px, 2px) rotate(-1deg);
}

60% {
    transform: translate(-3px, 1px) rotate(0deg);
}

70% {
    transform: translate(3px, 1px) rotate(-1deg);
}

80% {
    transform: translate(-1px, -1px) rotate(1deg);
}

90% {
    transform: translate(1px, 2px) rotate(0deg);
}

100% {
    transform: translate(1px, -2px) rotate(-1deg);
}
}

.cursor-point {
cursor: pointer;
}

:host ::ng-deep .mat-form-field {
    font-family: garamond !important;
    color: black;
    font-weight: 400;
  }
  
:host ::ng-deep .mat-form-field-wrapper {
padding-bottom: 0px;
}

:host ::ng-deep .mat-form-field-flex{
padding: 0px !important;
}

:host ::ng-deep .mat-select-value{
text-align:center
}


:host ::ng-deep .mat-form-field-underline {
display: none;
}

:host ::ng-deep .mat-select-panel {
    max-height: 250px !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/client-detail/client-detail.component.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;AACA,WAAW;AACX,4BAA4B;AAC5B,mCAAmC;AACnC;;;AAGA;AACA,sBAAsB;AACtB;;AAEA;AACA,wBAAwB;AACxB,UAAU;AACV;;AAEA;AACA,kBAAkB;AAClB,mCAAmC;AACnC,2CAA2C;AAC3C;;AAEA;AACA,gBAAgB;AAChB,aAAa;AACb,uBAAuB;AACvB,uBAAuB;AACvB,WAAW;AACX,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb,8BAA8B;AAC9B,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA;AACA,UAAU;AACV,gBAAgB;AAChB,eAAe;AACf,mBAAmB;AACnB,aAAa;AACb,kBAAkB;AAClB,mBAAmB;AACnB,0BAA0B;AAC1B,kBAAkB;AAClB,cAAc;AACd;AACA;;;;;AAKA;AACA,UAAU;AACV,kBAAkB;AAClB,UAAU;AACV,WAAW;AACX,YAAY;AACZ,MAAM;AACN,OAAO;AACP,eAAe;AACf;;AAEA;AACA,YAAY;AACZ,WAAW;AACX;;AAEA;AACA,YAAY;AACZ,8DAA8D;AAC9D,YAAY;AACZ,YAAY;AACZ,mBAAmB;AACnB,gBAAgB;AAChB,iDAAiD;AACjD;;AAEA;AACA,cAAc;AACd,gBAAgB;AAChB;;;AAGA;AACA,mBAAmB;AACnB,kCAAkC;AAClC;;AAEA;AACA,UAAU;AACV,aAAa;AACb,iDAAiD;AACjD,mBAAmB;AACnB,uBAAuB;AACvB,mBAAmB;AACnB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;;;AAGA;AACA,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd,SAAS;AACT;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd,SAAS;AACT,sBAAsB;AACtB;;AAEA;AACA;AACA;;AAEA;AACA,IAAI,UAAU;AACd,MAAM,UAAU;AAChB;;AAEA;AACA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,6CAA6C;AACjD;AACA;;AAEA;AACA,eAAe;AACf;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;EAClB;;AAEF;AACA,mBAAmB;AACnB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA;AACA;;;AAGA;AACA,aAAa;AACb;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["* {\n    font-family: Arial, Helvetica, sans-serif;\n}\n\nbody, input[text], button {\ncolor: #888;\n/* background-color:white; */\n/* font-family: Cambria, Georgia; */\n}\n\n\n#candidate-detail {\nbackground-color:white;\n}\n\n.srcoll-notes::-webkit-scrollbar {\n-webkit-appearance: none;\nwidth: 7px;\n}\n\n.srcoll-notes::-webkit-scrollbar-thumb {\nborder-radius: 4px;\nbackground-color: rgba(0, 0, 0, .5);\nbox-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n.rowcenter {\nmargin-top: 30px;\ndisplay: flex;\njustify-content: center;\nalign-items: flex-start;\nwidth: 100%;\nflex-direction: row;\n}\n\n.dropzone-container {\ndisplay: flex;\njustify-content: space-between;\nalign-items: center;\nflex-direction: row;\n}\n\n.dropzone {\nwidth: 75%;\nmin-width: 250px;\ncursor: pointer;\n/* height: 220px; */\npadding: 1rem;\ntext-align: center;\nborder-radius: 20px;\nborder: dashed 1px #979797;\nposition: relative;\nmargin: 0 auto;\nbox-shadow: 1px 1px 2px rgba(255, 255, 255, .6)\n}\n\n\n\n\n.dropzone input {\nopacity: 0;\nposition: absolute;\nz-index: 2;\nwidth: 100%;\nheight: 100%;\ntop: 0;\nleft: 0;\ncursor: pointer;\n}\n\nul {\npadding: 0px;\nmargin: 0px;\n}\n\n.dropzone label {\ncolor: white;\nbackground-image: linear-gradient(to right, #77A1D3, #79CBCA );\nheight: 32px;\nwidth: 150px;\nborder-radius: 20px;\npadding: 4px 8px;\nbox-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;\n}\n\n.dropzone h5 {\ncolor: #aaabad;\nfont-weight: 700;\n}\n\n\n.fileover {\nanimation: shake 1s;\nanimation-iteration-count:infinite;\n}\n\n.file-list {\nwidth: 90%;\ndisplay: flex;\nbox-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\nflex-direction: row;\njustify-content: center;\nalign-items: center;\nmargin-top: 15px;\nborder-radius: 10px;\npadding: 5px\n}\n\n\n.name {\nfont-size: 14px;\nfont-weight: 500;\ncolor: #353f4a;\nmargin: 0;\n}\n\n.size {\nfont-size: 12px;\nfont-weight: 500;\ncolor: #a4a4a4;\nmargin: 0;\nmargin-bottom: 0.25rem;\n}\n\n.info {\nwidth: 100%\n}\n\n@keyframes extend {\n0% {width: 75%}\n100% {width: 90%}\n}\n\n@keyframes shake {\n0% {\n    transform: translate(1px, 1px) rotate(0deg);\n}\n\n10% {\n    transform: translate(-1px, -2px) rotate(-1deg);\n}\n\n20% {\n    transform: translate(-3px, 0px) rotate(1deg);\n}\n\n30% {\n    transform: translate(3px, 2px) rotate(0deg);\n}\n\n40% {\n    transform: translate(1px, -1px) rotate(1deg);\n}\n\n50% {\n    transform: translate(-1px, 2px) rotate(-1deg);\n}\n\n60% {\n    transform: translate(-3px, 1px) rotate(0deg);\n}\n\n70% {\n    transform: translate(3px, 1px) rotate(-1deg);\n}\n\n80% {\n    transform: translate(-1px, -1px) rotate(1deg);\n}\n\n90% {\n    transform: translate(1px, 2px) rotate(0deg);\n}\n\n100% {\n    transform: translate(1px, -2px) rotate(-1deg);\n}\n}\n\n.cursor-point {\ncursor: pointer;\n}\n\n:host ::ng-deep .mat-form-field {\n    font-family: garamond !important;\n    color: black;\n    font-weight: 400;\n  }\n  \n:host ::ng-deep .mat-form-field-wrapper {\npadding-bottom: 0px;\n}\n\n:host ::ng-deep .mat-form-field-flex{\npadding: 0px !important;\n}\n\n:host ::ng-deep .mat-select-value{\ntext-align:center\n}\n\n\n:host ::ng-deep .mat-form-field-underline {\ndisplay: none;\n}\n\n:host ::ng-deep .mat-select-panel {\n    max-height: 250px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
